var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line, _line2, _line3, _line4, _line5, _line6, _line7, _path0, _path1, _path10, _line8, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 213,
    viewBox: "0 0 240 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.293 79.3828H117.723",
    stroke: "#2D91E9",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.178 81.3184L199.747 81.3184",
    stroke: "#2D91E9",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.85 118.795L129.053 108.611",
    stroke: "#2D91E9",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.621 41.9023L188.417 52.0862",
    stroke: "#2D91E9",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.773 135.684L157.773 121.281",
    stroke: "#2D91E9",
    strokeWidth: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.697 25.0137L159.697 39.4158",
    stroke: "#2D91E9",
    strokeWidth: 5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.447 119.629L186.316 109.373",
    stroke: "#2D91E9",
    strokeWidth: 5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.949 39.4473L130.081 49.7028",
    stroke: "#2D91E9",
    strokeWidth: 5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M180.057 80.3769C180.057 92.3756 170.598 101.99 159.067 101.99C147.535 101.99 138.076 92.3756 138.076 80.3769C138.076 68.3782 147.535 58.7637 159.067 58.7637C170.598 58.7637 180.057 68.3782 180.057 80.3769Z",
    fill: "#79B4E8",
    stroke: "#2D91E9",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 62.2793,
    y1: 183.711,
    x2: 239.241,
    y2: 183.711,
    stroke: "#2D91E9",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.32794e-7,
    y1: 183.711,
    x2: 34.9367,
    y2: 183.711,
    stroke: "#2D91E9",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.875,
    y1: 200.387,
    x2: 28.1028,
    y2: 200.387,
    stroke: "#79B4E8",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 134.793,
    y1: 192.908,
    x2: 145.426,
    y2: 192.908,
    stroke: "#79B4E8",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 82.7852,
    y1: 211,
    x2: 106.329,
    y2: 211,
    stroke: "#79B4E8",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 223.166,
    y1: 203.42,
    x2: 238.356,
    y2: 203.42,
    stroke: "#79B4E8",
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 193.15,
    y1: 197.842,
    x2: 205.302,
    y2: 197.842,
    stroke: "#79B4E8",
    strokeWidth: 4
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2148 209.209V145.536C37.2148 139.257 42.3154 134.166 48.6073 134.166C54.8991 134.166 59.9997 139.257 59.9997 145.536V209.209",
    stroke: "#2D91E9",
    strokeWidth: 4
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6717 135.684C73.6717 140.18 73.6717 149.944 73.6717 153.028C73.6717 156.882 71.8489 158.424 69.1147 158.424C66.9274 158.424 63.6464 158.424 62.2793 158.424",
    stroke: "#2D91E9",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3049 153.117C24.3049 156.715 24.3049 164.526 24.3049 166.993C24.3049 170.076 26.1276 171.309 28.8618 171.309C31.0492 171.309 34.3302 171.309 35.6973 171.309",
    stroke: "#2D91E9",
    strokeWidth: 4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 188.633,
    y1: 180.406,
    x2: 188.633,
    y2: 143.264,
    stroke: "#2D91E9",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M198.228 147.812V158.425C198.354 159.688 198 162.215 195.57 162.215C193.139 162.215 191.266 162.215 190.633 162.215",
    stroke: "#2D91E9",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5449 182.681L87.7221 163.731L112.406 155.771L122.659 165.626L133.292 167.521L139.747 182.681",
    stroke: "#2D91E9",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M164.81 181.921L156.835 169.035L135.949 172.825",
    stroke: "#2D91E9",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.4f919676c69f36262bd24a6708cca9a7.svg";
export { ForwardRef as ReactComponent };